/**
 * The main call is represented by an empty call_id on the wire. Internally it
 * still needs its own scope, and events must include a real string call_id.
 */
export const MAIN_CALL_SCOPE_ID = "main";

export function normalizeCallScopeId(callId) {
    if (typeof callId !== "string") {
        return null;
    }
    return callId || MAIN_CALL_SCOPE_ID;
}

export function isCallEventForScope(event, state) {
    const eventScopeId = normalizeCallScopeId(event?.call_id);
    return !!state.joinedCall
        && !!state.callOpen
        && !!event
        && event.room === state.room
        && eventScopeId !== null
        && eventScopeId === state.callScopeId;
}

export function shouldHydrateSnapshotParticipant(participant, selfId, callUsers) {
    const uid = participant?.user_id;
    const peerId = participant?.peer_id;
    return typeof uid === "string"
        && uid.length > 0
        && uid !== selfId
        && typeof peerId === "string"
        && peerId.trim().length > 0
        && !callUsers[uid];
}
